
import { Link } from 'react-router-dom';

export function Footer() {
  const footerLinks = {
    platform: {
      title: '플랫폼',
      links: [
        { name: '제품 카탈로그', href: '/products' },
        { name: '제조업체', href: '/manufacturers' },
        { name: '이용 가이드', href: '/guide' },
        { name: 'FAQ', href: '/faq' },
      ],
    },
    company: {
      title: '회사',
      links: [
        { name: '회사소개', href: '/about' },
        { name: '팀 소개', href: '/team' },
        { name: '파트너십', href: '/partnership' },
        { name: '채용', href: '/careers' },
      ],
    },
    support: {
      title: '고객지원',
      links: [
        { name: '문의하기', href: '/contact' },
        { name: '입점 문의', href: '/contact?type=partnership' },
        { name: '이용약관', href: '/terms' },
        { name: '개인정보처리방침', href: '/privacy' },
      ],
    },
  };

  return (
    <footer className="bg-gradient-to-b from-[#3B1E08] to-[#1F0F04] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* 브랜드 섹션 */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-orange-500 rounded-lg flex items-center justify-center">
                <i className="ri-ship-2-line text-white text-2xl"></i>
              </div>
              <span className="text-2xl font-bold font-montserrat">만선허브</span>
            </div>
            <p className="text-amber-100/60 mb-6 leading-relaxed">
              어선에 필요한 모든 물품을 한 곳에서.
              <br />
              전국의 제조업체와 선장·선주를 직접 연결하는 어선 물품 공급 플랫폼입니다.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-amber-900/40 rounded-lg flex items-center justify-center hover:bg-amber-500 transition-colors cursor-pointer"
              >
                <i className="ri-kakao-talk-fill text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-amber-900/40 rounded-lg flex items-center justify-center hover:bg-amber-500 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-amber-900/40 rounded-lg flex items-center justify-center hover:bg-amber-500 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-amber-900/40 rounded-lg flex items-center justify-center hover:bg-amber-500 transition-colors cursor-pointer"
              >
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* 링크 섹션 */}
          {Object.values(footerLinks).map((section, index) => (
            <div key={index}>
              <h4 className="font-bold text-lg mb-4 text-amber-100">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      to={link.href}
                      className="text-amber-200/50 hover:text-amber-400 transition-colors text-sm cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 하단 정보 */}
        <div className="border-t border-amber-500/15 pt-8">
          <div className="grid md:grid-cols-2 gap-6">
            <div className="text-sm text-amber-200/50">
              <p className="mb-2">
                <strong className="text-amber-100/80">만선허브</strong> | 대표: 홍길동
              </p>
              <p className="mb-2">사업자등록번호: 123-45-67890</p>
              <p className="mb-2">주소: 부산광역시 중구 중앙대로 123</p>
              <p>이메일: contact@manseonhub.com | 전화: 051-1234-5678</p>
            </div>

            <div className="text-sm text-amber-200/40 md:text-right">
              <p className="mb-4">© 2025 만선허브. All rights reserved.</p>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-amber-200/40 hover:text-amber-400 transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
